import { useEffect, useRef } from 'react'
import { X } from 'lucide-react'

export default function Modal({ title, children, onClose }: { title: string; children: React.ReactNode; onClose: () => void }) {
  const panel = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null
    panel.current?.focus()
    const keydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
      if (event.key !== 'Tab' || !panel.current) return
      const focusable = [...panel.current.querySelectorAll<HTMLElement>('button,input,select,textarea,a[href],[tabindex]:not([tabindex="-1"])')]
      if (!focusable.length) return
      const first = focusable[0], last = focusable[focusable.length - 1]
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus() }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
    }
    document.addEventListener('keydown', keydown)
    return () => { document.removeEventListener('keydown', keydown); previous?.focus() }
  }, [onClose])
  return <div className="fixed inset-0 z-[20000] flex items-center justify-center bg-slate-950/60 p-4" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
    <div ref={panel} tabIndex={-1} role="dialog" aria-modal="true" aria-labelledby="modal-title" className="w-full max-w-md rounded-2xl bg-white dark:bg-slate-900 dark:text-slate-100 border border-slate-200 dark:border-slate-800 shadow-2xl outline-none">
      <div className="flex items-center justify-between border-b border-slate-200 dark:border-slate-800 px-5 py-4"><h2 id="modal-title" className="text-lg font-semibold text-slate-900 dark:text-slate-100">{title}</h2><button type="button" className="icon-button" onClick={onClose} aria-label="Fechar"><X size={19} /></button></div>
      {children}
    </div>
  </div>
}
